<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
      <asideCom :activityIndex="9"></asideCom>
      <div class="my-content">
        <div class="top-choose">
          <div class="message" :class="{'choose':titleIndex===0}" @click="changeIndex(0)">{{$t('global.参与的活动')}}</div>
          <span v-if="userType == 2">|</span>
          <div
            class="modify-password"
            v-show="userType == 2"
            :class="{'choose':titleIndex===1}"
            @click="changeIndex(1)"
          >{{$t('global.发起的活动')}}</div>
        </div>
        <div class="order">
          <a
            href="javascript:;"
            v-if="userType == 2"
            class="create-activity"
            @click="gotoUrl('/activityLunch')"
          >+ {{$t('global.创建活动')}}</a>
          <div :class="{sort:contentIndex===0}" @click="mySignActivity(0)">
            <span class="orderby-icon-time" :class="{'active-time':contentIndex==0}"></span>{{$t('global.最新创作')}}
          </div>
          <div :class="{sort:contentIndex===1}" @click="mySignActivity(1)">
            <span class="orderby-icon-visit" :class="{'active-visit':contentIndex==1}"></span>{{$t('global.按浏览量')}}
          </div>
          <div :class="{sort:contentIndex===2}" @click="mySignActivity(2)">
            <span class="orderby-icon-zan" :class="{'active-zan':contentIndex==2}"></span>{{$t('global.按点赞数')}}
          </div>
          <div :class="{sort:contentIndex===3}" @click="mySignActivity(3)">
            <span class="orderby-icon-comment" :class="{'active-comment':contentIndex==3}"></span>{{$t('global.按评论数')}}
          </div>
        </div>
        <activity-content
          :dataList="list"
          :createShow="true"
          :otherstyle="true"
          @enterDetail="enterDetail"
          my_activity="true"
        />
        <pages
          :page-size="pagerParam.pageSize"
          :page-count="pagerParam.pageCount"
          :current-page.sync="pagerParam.currentPage"
          :total="pagerParam.total"
          @current-page-changed="OnCurrentPageChanged"
        ></pages>
      </div>
    </div>
    <service></service>
    <ActivityDialog @close="showDialog=false" v-if="showDialog" />
  </main-layout>
</template>

<script type="text/ecmascript-6">
import ActivityDialog from "@/pages/dialog/ActivityDialog";
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";
import pages from "@/components/pages.vue";
import ActivityContent from "@/components/activity/ActivityContent";
import ContentEmpty from "@/components/ContentEmpty.vue";
export default {
  name: "MySpecialSubject",metaInfo() {
    return {
      title: this.$t("global.我的活动") + " | MANA"
    };
  },

  data() {
    return {
      contentIndex: 0,
      titleIndex: 0,
      list: [],
      listLength: -1,
      userType: 2,
      orderList: [
        {
          name: this.$t('global.最新创作'),
          imgType: "/static/peopleCenter/new.png"
        },
        {
          name: this.$t('global.按浏览量'),
          imgType: "/static/peopleCenter/eye.png"
        },
        {
          name: this.$t('global.按点赞数'),
          imgType: "/static/peopleCenter/hand.png"
        },
        {
          name: this.$t('global.按评论数'),
          imgType: "/static/peopleCenter/message.png"
        }
      ],
      pagerParam: {
        pageSize: 12,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      showDialog: false
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
    pages,
    ActivityContent,
    ContentEmpty,
    ActivityDialog
  },
  computed: {
    content() {
      if (this.titleIndex === 0) {
        return this.$t('global.没有参与的活动');
      } else if (this.titleIndex === 1) {
        return this.$t('global.没有发起的活动');
      }
    }
  },
  created() {
    this.mySignActivity(0);
    this.$http.get("/api/u/info/get").then(response => {
      let data = response.data;
      this.userType = data.userType;
    });
  },
  methods: {
    gotoUrl() {
      if (this.userType == 2) {
        if (this.activityIndex === 3) {
          this.$router.push("/addmatch");
        } else {
          this.showDialog = true;
        }
      } else {
        this.$router.push("/ApplyIdentification");
        this.$message({
          showClose: true,
          message: this.$t('global.发起活动需要是认证的企业用户')
        });
      }
    },
    changeIndex(index) {
      this.titleIndex = index;
      if (index === 0) {
        this.mySignActivity(0, 1);
      } else {
        this.myCreateActivity(0, 1);
      }
    },
    mySignActivity(index, pageI) {
      this.contentIndex = index;
      let order = "";
      switch (index) {
        case 0:
          order = "createTime";
          break;
        case 1:
          order = "viewCount";
          break;
        case 2:
          order = "likeCount";
          break;
        case 3:
          order = "commentCount";
          break;
      }
      this.$http
        .get("/api/u/activity/signList", {
          params: {
            category: 1,
            orderBy: order,
            pageIndex: pageI || this.pagerParam.currentPage,
            pageSize: this.pagerParam.pageSize
          }
        })
        .then(response => {
          let data = response.data;
          this.list = data.list;
          // this.pagerParam.pageSize = data.pageSize;
          this.pagerParam.total = data.totalRecord;
          this.pagerParam.pageCount = data.totalPage;
          this.pagerParam.currentPage = data.pageIndex;
          this.listLength = this.list.length;
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      if (this.titleIndex === 1) {
        this.myCreateActivity(this.contentIndex);
      } else {
        this.mySignActivity(this.contentIndex);
      }
    },
    myCreateActivity(index, pageI) {
      this.contentIndex = index;
      let order = "";
      switch (index) {
        case 0:
          order = "createTime";
          break;
        case 1:
          order = "viewCount";
          break;
        case 2:
          order = "likeCount";
          break;
        case 3:
          order = "commentCount";
          break;
      }
      this.$http
        .get("/api/u/activity/createList", {
          params: {
            category: 1,
            orderBy: order,
            pageIndex: pageI || this.pagerParam.currentPage,
            pageSize: this.pagerParam.pageSize
          }
        })
        .then(response => {
          let data = response.data;
          this.list = data.list;
          // this.pagerParam.pageSize = data.pageSize;
          this.pagerParam.total = data.totalRecord;
          this.pagerParam.pageCount = data.totalPage;
          this.pagerParam.currentPage = data.pageIndex;
          this.listLength = this.list.length;
        });
    },
    enterDetail: function({ id, category }) {
      switch (category) {
        case 1:
        case 2:
          this.$router.push({
            path: `/activity/${id}/detail`
          });
          break;
        case 3:
          this.$router.push({
            path: `/activityMatch/${id}/introduction`
          });
          break;
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
/* .myJoinWrap,.myCreateWrap */
/* padding 0.25rem 1.1rem 0 */
.el-tooltip__popper.is-light {
  border: none;
}

.operate:hover {
  background-color: #180826 !important;
  border-radius: 0.08rem;
}

.operate {
  width: 0.74rem;
  height: 0.3rem;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.12rem 0;
  background: url('/static/peopleCenter/dot.png') no-repeat;
  background-size: 100%;
  border: none !important;

  span {
    display: block;
  }
}

.line {
  display: inline-block;
  margin: 0 0.1rem 0 0.14rem;
}

.content-wrap {
  display: flex;
  flex-wrap: wrap;
}

.item {
  width: 5.1rem;
  margin: 0.26rem 0.6rem 0 0;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.08rem;

  &:nth-child(2n) {
    margin-right: 0;
  }
}

.item-img {
  /* width 3.8rem */
  cursor: pointer;
  position: relative;
  height: 2.15rem;
  background: url('/static/peopleCenter/item.png') no-repeat;
  background-size: cover;
}

.content {
  padding: 0 0.2rem;
  color: #333333;

  .top {
    font-size: 0.22rem;
    font-weight: bold;
    margin-top: 0.16rem;
  }

  .center {
    color: #777777;
    margin-top: 0.06rem;
    font-size: 0.14rem;
  }

  .bottom {
    display: flex;
    border-top: 1px solid #F4F4F4;
    justify-content: space-between;
    line-height: 0.55rem;
    margin-top: 0.2rem;

    .operate-wrap {
      font-size: 0.16rem;
      line-height: 0.55rem;
      display: flex;

      img {
        margin: -0.02rem 0.03rem 0 0;
      }

      .delete-one {
        margin-left: 0.1rem;
      }

      .editIMG {
        width: 0.16rem;
        height: 0.16rem;
      }

      .deleteIMG {
        width: 0.13rem;
        height: 0.13rem;
      }
    }

    .error {
      color: #ff0000;
    }
  }
}

.my-content {
  width: 870px;
  background-color: #ffffff;
  padding: 0.5rem 0.6rem;
  border-radius: 0.08rem;

  .top-choose {
    display: flex;
    // justify-content: center;
    font-size: 0.26rem;
    color: #707070;

    div {
      cursor: pointer;
    }
    span {
      display: block;
      margin: 0 0.65rem;
    }

    .choose {
      color: #333333;
      font-weight: bold;
    }
  }
}
.body{
  background: #FAFAFA;
}
.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;
}

.order {
  display: flex;
  position: relative;
  height: 80px;
  /* width 16rem */
  overflow: hidden;
  margin: 0 auto;
  color: #777777;
  line-height: 0.17rem;

  .sort {
    color: #0060ff;
    font-weight: bold;
  }

  >div {
    margin: 0.5rem 0 0 0.3rem;
    cursor: pointer;

    &:first-child {
      margin: 0.5rem 0 0 0;
    }
  }

  img {
    width: 0.16rem;
    margin-top: -0.04rem;
  }

  span {
    display: inline-block;
    margin-left: 0.1rem;
  }
}

.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/time.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.18rem;
  background: url('/static/explore/visit.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/zan.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/comment.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.order .active-time {
  background: url('/static/explore/focusTime.png') no-repeat center center;
  background-size: contain;
}

.order .active-visit {
  background: url('/static/explore/focusVisit.png') no-repeat center center;
  background-size: contain;
}

.order .active-zan {
  background: url('/static/explore/focusZan.png') no-repeat center center;
  background-size: contain;
}

.order .active-comment {
  background: url('/static/explore/focusComment.png') no-repeat center center;
  background-size: contain;
}

.order .create-activity {
  position: absolute;
  top: 20px;
  right: 0;
  height: 40px;
  padding: 0 10px;
  line-height: 40px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  background: #3664ED;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/activity/Activity.vue